import type { CustomerRegisterApi } from './customer-register-api.types';

import http from './customer-register-api.http';

export default {
  getRegistrationDetails: async ({ projectId }: CustomerRegisterApi.GetRegistrationDetailsParams) => {
    const res = await http.get<CustomerRegisterApi.RegistrationDetailsResponse>(
      `/registration/details/${projectId}`,
    );

    return res.data;
  },
};
